// extracted by mini-css-extract-plugin
export default {"bar":"TabBar_bar__vTsxC","tab":"TabBar_tab__VdTMM","on":"TabBar_on__nFHfM"};